import React from 'react';
import Input from '../Input/Input';
import './Form.scss';

const Form=({list,btn})=>{
    return(
        <div data-aos="fade-left"
        data-aos-delay={100}  className="hub-form">
         <h2>Fill out the form to access the webinar.</h2>
         {list.map((d) =>{
             return(
                 <Input {...d}/>
             )
         })}
         <button>{btn}</button>
        </div>
    )
};
export default Form ;